(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller(
			'workbenchConfiguration',
			workbenchConfiguration
		);

	workbenchConfiguration.$inject = [
		'$rootScope',
		'$scope',
		'$timeout'
	];

	function workbenchConfiguration($rootScope, $scope, $timeout) {
		var vm = this;
	}
})();
